export enum TabType {
  home = 'home',
  databases = 'databases',
  jobs = 'jobs',
  jobRequests = 'jobRequests',
  diagnostics = 'disgnostics'
}

export const tabNames = {
  [TabType.home]: 'Overview',
  [TabType.databases]: 'Databases',
  [TabType.jobs]: 'Jobs',
  [TabType.jobRequests]: 'Job Requests',
  [TabType.diagnostics]: 'Diagnostics',
}
